import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ReportingTable from "./ReportingTable";
import ReportingTextTable3am from "./ReportingTextTable3am";
import ReportingTextTable5min from "./ReportingTextTable5min";

function Reporting() {
  const [activeTab, setActiveTab] = React.useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className="Plans">
      <div className="main">
        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="Reporting Tabs"
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Reporting Table" />
          <Tab label="Reporting Test Table 3am" />
          <Tab label="Reporting Test Table 5min" />
        </Tabs>
        <Box p={3}>
          {activeTab === 0 && <ReportingTable />}
          {activeTab === 1 && <ReportingTextTable3am />}
          {activeTab === 2 && <ReportingTextTable5min />}
        </Box>
      </div>
    </div>
  );
}

export default Reporting;
